import { Component, Vue } from 'vue-property-decorator';
import BackToTop from '@/components/BackToTop/BackToTop.vue';

@Component({
  components: { BackToTop },
})
export default class BackToTopModule extends Vue {}
